import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// Helpers
import { formatCurrency } from '@eig-builder/core-utils/helpers/currency-helper'
import DiscountTypes from '../../../../core/enums/discounts'

// Other
import Text from 'localize'
import './lang'
import Typography from '@eig-builder/core-ui/Typography'

const getAppliedDiscount = (couponType, amount, currency) => {
  switch (couponType) {
    case DiscountTypes.PRICE:
      return <Text message='modules.cart.components.discount.valid' values={[formatCurrency(amount || 0, currency)]} />
    case DiscountTypes.PERCENTAGE:
      return <Text message='modules.cart.components.discount.valid' values={[`${amount || 0}%`]} />
    case DiscountTypes.FREE_SHIPPING:
      return <Text message='modules.cart.components.discount.freeShipping' />
  }
}

class DiscountListItem extends PureComponent {
  static propTypes = {
    couponType: PropTypes.number,
    amount: PropTypes.number,
    currency: PropTypes.object,
    onRemove: PropTypes.func
  }

  render () {
    const { onRemove = () => {}, couponType, amount, currency } = this.props

    return (

      <div className='row no-border align-items-center'>
        <div className='col-auto d-flex align-items-center'>
          <i className='material-icons '>check_circle</i>
        </div>
        <div className='col'>
          {getAppliedDiscount(couponType, amount, currency)}
        </div>
        <div className='col-auto'>
          <Typography onClick={onRemove} variant='link2'>
            <Text message='modules.cart.components.discount.remove' />
          </Typography>
        </div>
      </div>
    )
  }
}

export default DiscountListItem
